export default {
	PUT_AGENDA_DATE(state, payload) {
		state.date = payload;
	},
	SET_AGENDA_HOMEWORK(state, payload) {
		state.homework = payload;
	},
	SET_AGENDA(state, payload) {
		state.agenda = payload;
	},
	PUT_AGENDA_WATER(state, payload) {
		state.agenda.water = payload;
	},
	PUT_AGENDA_HUMOR(state, payload) {
		state.agenda.humor = payload;
	},
	PUT_AGENDA_URINE(state, payload) {
		state.agenda.piss = payload;
	},
	PUT_AGENDA_BRUSH(state, payload) {
		state.agenda.brush = payload;
	},
	PUT_AGENDA_DIAPER_QUANTITY(state, payload) {
		state.agenda.diaperQuantity = payload;
	},
	PUT_AGENDA_BATH_QUANTITY(state, payload) {
		state.agenda.bathQuantity = payload;
	},
	PUT_AGENDA_MEAL_PORTION(state, payload) {
		state.agenda.meals[payload.index].mealPortion = payload.value;
	},
	PUT_AGENDA_BEVERAGE_PORTION(state, payload) {
		state.agenda.meals[payload.index].beveragePortion = payload.value;
	},
	POST_AGENDA_ADDITIONAL_FOOD_ITEM(state, payload) {

		if (!state.agenda.additionalMeals) {
			state.agenda.additionalMeals = [];
		}

		state.agenda.additionalMeals.push(payload);

	},
	PUT_AGENDA_ADDITIONAL_FOOD_ITEM(state, payload) {

		state.agenda.additionalMeals[payload.index] = payload;
		delete state.agenda.additionalMeals[payload.index].index;

	},
	DELETE_ADDITIONAL_MEALS_ITEM(state, payload) {
		state.agenda.additionalMeals.splice(payload, 1);
	},
	PUT_AGENDA_SCHEDULED_MEDICINE(state, payload) {
		state.agenda.regularMedicines[payload.index].isTaken = payload.value;
	},
	PUT_AGENDA_OBSERVATION(state, payload) {
		state.agenda.observation = payload;
	},
	PUT_AGENDA_ACTIVITIES(state, payload) {
		state.agenda.activities[payload.index].fulfilled = payload.value;
	},
	PUT_AGENDA_PARTICIPATION(state, payload) {
		state.agenda.participation = payload;
	},
	PUT_AGENDA_PRESENCE(state, payload) {
		state.agenda.presence = payload;
	},
	POST_AGENDA_QUESTIONS(state, payload) {

		if (!state.agenda.questions) {
			state.agenda.questions = [];
		}

		state.agenda.questions[payload.index].answer = payload.value;

	},
	PUT_AGENDA_QUESTIONS(state, payload) {
		state.agenda.questions[payload.index].answer = payload.value;
	},
	DELETE_NAP_ITEM(state, payload) {
		state.agenda.sleepy.splice(payload, 1);
	},
	DELETE_EVACUATION_ITEM(state, payload) {
		state.agenda.evacuation.splice(payload, 1);
	},
	DELETE_EVENTUAL_MEDICINE_ITEM(state, payload) {
		state.agenda.eventualMedicines.splice(payload, 1);
	},
	POST_AGENDA_NAPS_ITEM(state, payload) {

		if (!state.agenda.sleepy) {
			state.agenda.sleepy = [];
		}

		state.agenda.sleepy.push(payload);

	},
	PUT_AGENDA_NAPS_ITEM(state, payload) {

		state.agenda.sleepy[payload.index] = payload;
		delete state.agenda.sleepy[payload.index].index;

	},
	POST_AGENDA_EVENTUAL_MEDICINE_ITEM(state, payload) {

		if (!state.agenda.eventualMedicines) {
			state.agenda.eventualMedicines = [];
		}

		state.agenda.eventualMedicines.push(payload);

	},
	PUT_AGENDA_EVENTUAL_MEDICINE_ITEM(state, payload) {

		state.agenda.eventualMedicines[payload.index] = payload;
		delete state.agenda.eventualMedicines[payload.index].index;

	},
	POST_EVACUATION_ITEM(state, payload) {

		if (!state.agenda.evacuation) {
			state.agenda.evacuation = [];

		}

		state.agenda.evacuation.push(payload);

	},
	PUT_EVACUATION_ITEM(state, payload) {

		state.agenda.evacuation[payload.index] = payload;
		delete state.agenda.evacuation[payload.index].index;

	},
	PUT_AGENDA_SCHEDULED_HOMEWORK(state, payload) {
		state.agenda.scheduledHomework[payload.index].status = payload.value;
	},
	PUT_COMPLETION_STATUS(state, payload) {
		state.completionStatus[payload.key] = payload.value;
	},
	PUT_EXCLUSIVE_HOMEWORK(state, payload) {
		state.agenda.exclusiveHomework.themes[payload.index] = payload.theme;
	},
	PUT_EXCLUSIVE_HOMEWORK_ID(state, payload) {
		state.agenda.exclusiveHomework.themes[payload.index] = payload.themes[payload.index];
	},
	PUSH_REPLACEMENT_ITEM(state, payload) {

		if (!state.agenda.replacementItens) {
			state.agenda.replacementItens = [];
		}

		state.agenda.replacementItens.push(payload);

	},
	PUT_REPLACEMENT_ITEM(state, payload) {

		delete payload.value.index;
		state.agenda.replacementItens[payload.index] = payload.value;

	},
	DELETE_REPLACEMENT_ITEM(state, payload) {
		state.agenda.replacementItens.splice(payload, 1);
	}
};



// WEBPACK FOOTER //
// ./sources/app/agenda/mutations.js